import type { GroupBase } from "react-select";
import type { AsyncProps } from "react-select/async";
import AsyncSelect from "react-select/async";
import {
	StyledError,
	StyledInputContainer,
	StyledLabel,
} from "../../input-styles";
import { selectClassName, selectStyles } from "../styles";

interface Props<
	Option,
	IsMulti extends boolean,
	Group extends GroupBase<Option>,
> extends AsyncProps<Option, IsMulti, Group> {
	id?: string;
	label?: string;
	error?: string;
}

const AsyncReactSelect = <
	Option,
	IsMulti extends boolean = false,
	Group extends GroupBase<Option> = GroupBase<Option>,
>({
	id,
	label,
	error,
	...props
}: Props<Option, IsMulti, Group>) => {
	return (
		<StyledInputContainer>
			<StyledLabel htmlFor={id}>{label}</StyledLabel>
			<AsyncSelect
				{...props}
				className={`${selectClassName} ${props.className ?? ""}`}
				styles={selectStyles<Option, IsMulti, Group>()}
			/>
			{error && <StyledError>{error}</StyledError>}
		</StyledInputContainer>
	);
};

export default AsyncReactSelect;
